import Image, { ImageProps } from 'next/image'

import { CloudinaryAsset } from 'types'
import { getCloudinarySrc } from './get-cloudinary-src'
import { ContentfulComponentWithImages, IMAGE_COMPONENTS_TRANSFORMATIONS } from './common'
import { useState } from 'react'

const QUALITY = 65
// priority for the elements that contains images at indexes 0, 1
const ELEMENT_INDEX_LIMIT = 1

export const validatePriorityImage = ({ index }: { index?: string }): boolean => {
  const firstLevelPosition = Number(index?.split('.')[0])

  return firstLevelPosition <= ELEMENT_INDEX_LIMIT
}

export const NextImageWrapper = ({
  asset,
  contentType,
  sizes,
  fixedSize,
}: {
  asset: Pick<ImageProps, 'className'> & CloudinaryAsset
  contentType?: ContentfulComponentWithImages
  sizes?: string
  // Image always displays at its width/height: omit `sizes` so Next emits only 1x/2x srcset candidates
  fixedSize?: boolean
}) => {
  const { className = '', priority, context, height, width } = asset
  const cloudinarySrc = getCloudinarySrc({ asset, contentType })
  const [imgSrc, setImgSrc] = useState(cloudinarySrc)
  const imageSizes =
    contentType && IMAGE_COMPONENTS_TRANSFORMATIONS[contentType]
      ? IMAGE_COMPONENTS_TRANSFORMATIONS[contentType].sizes
      : '100vh'
  if (height && width) {
    return (
      <Image
        priority={priority}
        {...(!priority && { loading: 'lazy' })}
        src={imgSrc}
        quality={QUALITY}
        alt={context?.custom.alt ?? ''}
        className={className ?? ''}
        sizes={fixedSize && !sizes ? undefined : sizes ?? imageSizes}
        height={height}
        width={width}
        style={{ objectFit: 'cover' }}
        onError={() => setImgSrc('/images/image-coming-soon.jpg')}
      />
    )
  }
  return (
    <Image
      priority={priority}
      src={imgSrc}
      quality={QUALITY}
      alt={context?.custom.alt ?? ''}
      className={className ?? ''}
      sizes={sizes ?? imageSizes}
      style={{ objectFit: 'cover' }}
      fill
      onError={() => setImgSrc('/images/image-coming-soon.jpg')}
    />
  )
}
